export const getId = (id) => () => document.getElementById(id) && document.getElementById(id).value;
